export default function hideVirtualKeyboard() {
  if (
    document.activeElement instanceof HTMLElement &&
    typeof document.activeElement.blur === "function"
  ) {
    document.activeElement.blur();
  }
}
